module.exports = __webpack_public_path__ + "media/bootstrap-icons/map-fill-b18eecb4.svg";